import * as React from 'react';
import {
  useEffect,
  useState,
  useMemo,
  FC,
} from 'react';
import { Tab } from 'react-bootstrap';
import { Bottom } from 'moduleBase/modules/menu/components/desktop/Bottom';
import { Tabs } from 'moduleBase/modules/menu/components/desktop/Tabs';
import { TabsContent } from 'moduleBase/modules/menu/components/desktop/TabsContent';
import { State } from 'moduleBase/types/State';
import { bindActionCreators } from 'redux';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import {
  MESSAGE_TYPE_DEAL_STATUS_CHANGE,
  MESSAGE_TYPE_MENU_MAIN_UPDATE,
  MESSAGE_TYPE_PROJECT_DELETE,
} from 'srcJs/components/realtime-notification/constants/constants';
import { menuMainLoad } from 'moduleBase/modules/menu/actions/main-load';
import { LAYOUT_SMALL_COOKIE_KEY, REDUCER_MENU_NAME } from 'moduleBase/modules/menu/constants';
import SidebarArrow from 'images/sidebar-arrow.svg';
import LogoShortPrimaryWithSupport from 'images/logo-short-primary-with-support.svg';
import { StateType } from 'moduleBase/modules/menu/types/StateType';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { NavLink } from 'components/router/NavLink';
import { useUserData } from 'components/user/hooks/use-user-data';
import { SelectCallback } from 'react-bootstrap/helpers';
import Cookies from 'js-cookie';
import { menuMainLoadChannels, menuMainLoadProjects } from 'moduleBaseMenu/actions/load-sub-menu';

type DispatchPropTypes = {
  load: () => void;
  loadChannels: () => void;
  loadProjects: () => void;
}

type PropsType = StateType & DispatchPropTypes;

const DesktopNav: FC<PropsType> = ({
  menu,
  activeId,
  load,
  loadChannels,
  loadProjects,
}) => {
  const [activeTab, setActiveTab] = useState(menu.activeBlock);
  const [isOpen, setOpen] = useState(Cookies.get(LAYOUT_SMALL_COOKIE_KEY) === undefined);
  const { isOwner } = useUserData();

  const defaultBottomData = useMemo(() => {
    const activeBlock = menu.blocks.find((block) => block.id === activeTab);
    return activeBlock.bottom;
  }, []);

  const handlerMenuMainUpdate = () => {
    load();
  };

  const handlerDealStatusChange = () => {
    loadChannels();
  };

  const handlerProjectDelete = () => {
    loadProjects();
  };

  const open = () => {
    setOpen(true);
    Cookies.remove(LAYOUT_SMALL_COOKIE_KEY);
  };

  const close = () => {
    setOpen(false);
    Cookies.set(LAYOUT_SMALL_COOKIE_KEY, '1', { expires: 365 });
  };

  const toggle = () => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };

  const handlerTabsSelect: SelectCallback = () => {
    if (!isOpen) {
      open();
    }
  };

  useEffect(() => {
    realtimeNotification.addListener(MESSAGE_TYPE_MENU_MAIN_UPDATE, handlerMenuMainUpdate);
    if (isOwner) {
      realtimeNotification.addListener(MESSAGE_TYPE_DEAL_STATUS_CHANGE, handlerDealStatusChange);
    }
    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_DELETE, handlerProjectDelete);

    return () => {
      realtimeNotification.removeListener(handlerMenuMainUpdate);
      if (isOwner) {
        realtimeNotification.removeListener(handlerDealStatusChange);
      }
      realtimeNotification.removeListener(handlerProjectDelete);
    };
  }, []);

  return (
    <div className={`desktop-nav row flex-nowrap no-gutters d-none d-lg-flex ${isOpen ? 'opened' : 'closed'}`}>
      <Tab.Container id="platform-tabs" activeKey={activeTab} onSelect={setActiveTab}>
        <div className="col-auto d-flex flex-column align-items-center bg-light py-16p">
          <NavLink to="/" className="desktop-nav__logo mb-4p">
            <img src={LogoShortPrimaryWithSupport} className="desktop-nav__logo-img" />
          </NavLink>
          <Tabs blocks={menu.blocks} onSelect={handlerTabsSelect} tools={menu.tools} faq={menu.faq} />
          <button className="btn btn-secondary btn-square p-0 mt-auto" type="button" onClick={toggle}>
            <img src={SidebarArrow} className="desktop-nav__toggle-icon" />
          </button>
        </div>
        <div className="desktop-nav-menu col min-w-0 pt-16p px-16p d-flex flex-column custom-scroll">
          <TabsContent
            blocks={menu.blocks}
            activeId={activeId}
            supportInfo={menu.supportInfo}
            tools={menu.tools}
            faq={menu.faq}
          />
          <Bottom bottomData={defaultBottomData} />
        </div>
      </Tab.Container>
    </div>
  );
};

export default connect(DesktopNav, {
  mapStateToProps: (state: State) => state[REDUCER_MENU_NAME],
  mapDispatchToProps: (dispatch) => (bindActionCreators({
    load: menuMainLoad,
    loadChannels: menuMainLoadChannels,
    loadProjects: menuMainLoadProjects,
  }, dispatch)),
});
